export function mergeArray(parent, children) {
  var valueArr = parent.map(function(item) {
    return item._id
  })
  children.forEach((element) => {
    if (valueArr.indexOf(element._id) < 0) {
      parent.push(element)
    }
  })
  return parent
}
